export default {
  DOWNLOAD_START: 'Downloaden… Een ogenblik geduld…',
  DOWNLOAD_SUCCESS: 'Danken! U kunt dit venster nu sluiten.'
}
